import { useEffect } from "react";

function useDocumentTitle(title) {
  useEffect(() => {
    document.title = `${title} - Aktiva Transaksional Email`;
  }, [title]);
}

export default useDocumentTitle;
